import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { testimonials } from '../data/businessData';

const TestimonialsSection: React.FC = () => {
  return (
    <section id="testimonials" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">What Our Customers Say</h2>
          <p className="lead text-muted">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <Row>
          {testimonials.map((testimonial) => (
            <Col lg={6} className="mb-4" key={testimonial.id}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <p className="card-text text-muted mb-4">
                    "{testimonial.comment}"
                  </p>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="fw-bold mb-1">{testimonial.name}</h6>
                      <small className="text-muted">{testimonial.service}</small>
                    </div>
                    <div className="text-warning">
                      {'★'.repeat(testimonial.rating)}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TestimonialsSection;